import { Navigate, useLocation } from 'react-router-dom';
import useViewer from 'components/Viewer/ViewerContext/useViewer';

const RequireAuth = ({ children }) => {
  const { viewer } = useViewer();
  const location = useLocation();
  const isAuthenticated = viewer;

  if (!isAuthenticated) {
    return <Navigate to='/login' state={{ from: location }} replace />;
  }

  return children;
};

export default RequireAuth;
